import { render, staticRenderFns } from "./PrivacyPolicyApp.vue?vue&type=template&id=1f84e90b&"
import script from "./PrivacyPolicyApp.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports